import { API, ApiResponseBase, CustomAxiosError } from "../../../../../logics/api-config";
import { IAccounting } from "../../../../../utils/interfaces/Accounting/Recap/IAccounting";
import { useQuery, UseQueryResult } from "react-query";

export interface ApiResponse extends ApiResponseBase {
    data: IAccounting;
}

async function doGet(year: string, month: string): Promise<IAccounting> {
    const response = await API.get(`/accounting/recap/bookings/${year}/${month}`);
    return response?.data;
}

const useApiGetAccountingBookingRecap = (
    year: string,
    month: string,
    options: any = {}
): UseQueryResult<IAccounting, CustomAxiosError> => {
    return useQuery<IAccounting, CustomAxiosError>(
        ["getAccountingBookingRecap", year, month],
        () => doGet(year, month),
        { ...options }
    );
};

export default useApiGetAccountingBookingRecap;